export const algo_1_file = '/PythonCode/algo_1.py';